import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Agency } from '../../../../../../models/agency';
import { AgencyService } from '../../../../../../services/agency.service';
import { DataService } from '../../../../../../_services/data.service';

@Component({
    selector: 'app-create-agency',
    templateUrl: './create-agency.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreateAgencyComponent extends BaseComponent implements OnInit {
    model: Agency = new Agency();

    constructor(
        private agencyService: AgencyService,
        private dataService: DataService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.initPhoneMasks();
        this.initTaxMasks();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    initTaxMasks() {
        (<any>$('#taxNumber')).inputmask({
            mask: '99999999999'
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    createAgency() {
        var _self = this;
        Helpers.setLoading(true);
        this.model.publisherId = this.dataService.publisherId;
        this.model.phone = (<any>$('#phone')).val();
        this.model.taxNumber = (<any>$('#taxNumber')).val();
        this.agencyService.create(this.model).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            this.model.name = '';
            setTimeout(function() {
                _self.router.navigate(['/publisher/agency/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/agency/create-agency/create-agency.component.ts